import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../translations/translations';
import {
  COOKIE_CONSENT_ACCEPTED,
  COOKIE_CONSENT_REJECTED,
  getCookieConsent,
  loadAnalyticsScripts,
  setCookieConsent
} from '../utils/cookieConsent';

const CookieConsentBanner = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    if (consent === COOKIE_CONSENT_ACCEPTED) {
      loadAnalyticsScripts();
      return;
    }
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  useEffect(() => {
    const handleOpenSettings = () => {
      setIsVisible(true);
    };

    window.addEventListener('historio:open-cookie-settings', handleOpenSettings);
    return () => window.removeEventListener('historio:open-cookie-settings', handleOpenSettings);
  }, []);

  const acceptCookies = () => {
    setCookieConsent(COOKIE_CONSENT_ACCEPTED);
    loadAnalyticsScripts();
    setIsVisible(false);
  };

  const rejectCookies = () => {
    setCookieConsent(COOKIE_CONSENT_REJECTED);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-dark-border bg-dark/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:px-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="text-left">
          <p className="text-base font-semibold text-light">
            {t('cookieBannerTitle', language)}
          </p>
          <p className="mt-1 text-sm text-light-secondary">
            {t('cookieBannerDescription', language)}
          </p>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={rejectCookies}
            className="rounded border border-dark-border px-4 py-2 text-sm font-medium text-light-secondary hover:border-bronze hover:text-bronze transition-colors"
          >
            {t('rejectNonEssential', language)}
          </button>
          <button
            type="button"
            onClick={acceptCookies}
            className="rounded bg-bronze px-4 py-2 text-sm font-semibold text-white hover:bg-bronze-dark transition-colors"
          >
            {t('acceptAllCookies', language)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;

